export const BASE = {
  activeClass: "active",
};

export const CLASS_HOLDER_CORE_SELECTION =
  "holder-of-core-selection-guide-columns-v2";
export const CLASS_HOLDER_FINISHING_GUIDE = "holder-of-finishing-guide-columns";

export const CLASS_ITEM_CORE_SELECTION = "item";
export const CLASS_ITEM_FINISHING_GUIDE = "finishing-item";

export const MAX_COLUMNS_OF_VARIANT = 6;
